module.exports = __webpack_public_path__ + "img/logo.18c78582.png";